import React from 'react';
import Container from '../ui/Container';
import Button from '../ui/Button';
import Sparkle from '../ui/Sparkle';
import { APP } from './siteData';

/** Closing call-to-action — a big rounded plum panel with sparkles. */
const CtaBand = ({
  eyebrow = 'Your shop is waiting',
  title = 'Start your online business today.',
  text = 'Join thousands of South African makers and creators. 14-day free trial, no credit card required.',
  primary = { label: 'Start for free', href: APP.signUp },
  secondary = { label: 'See pricing', href: '/pricing-and-features' },
  testId = 'cta-band',
}) => (
  <section className="bg-white py-14 md:py-20" data-testid={testId}>
    <Container>
      <div className="relative overflow-hidden rounded-5xl bg-ink text-center px-6 py-16 md:py-24">
        <Sparkle size={140} color="#95a8e6" className="pointer-events-none absolute -top-6 right-[8%] opacity-40 hidden sm:block" />
        <Sparkle size={72} color="#ffb442" className="pointer-events-none absolute bottom-[12%] left-[8%] opacity-90" />
        <Sparkle size={44} color="#ffffff" className="pointer-events-none absolute top-[22%] left-[24%] opacity-20 hidden sm:block" />
        <div className="relative">
          <span className="inline-flex items-center gap-2 text-amber font-extrabold uppercase tracking-[0.14em] text-xs">
            <Sparkle size={14} color="#ffb442" /> {eyebrow}
          </span>
          <h2 className="mt-4 mx-auto max-w-[16ch] text-white font-extrabold text-[clamp(2rem,5vw,3.5rem)] leading-[1.05] tracking-tight">{title}</h2>
          <p className="mt-5 mx-auto max-w-[46ch] text-white/70 text-lead">{text}</p>
          <div className="mt-9 flex flex-wrap gap-3.5 justify-center">
            <Button href={primary.href} size="lg">{primary.label}</Button>
            {secondary && <Button href={secondary.href} variant="secondary" size="lg" icon={false} className="!bg-white/10 !border-white/25 !text-white hover:!bg-white/20 hover:!border-white/40">{secondary.label}</Button>}
          </div>
        </div>
      </div>
    </Container>
  </section>
);

export default CtaBand;
